
function CONTACT_TYPE( id ){
  if(id === '1') {
    return 'เจ้าของรถ'
  } else if(id === '2') {
    return 'อู่ / ศูนย์บริการ / รถยก'
  } else if(id === '9') {
    return 'อื่น ๆ'
  } else {
    return 'เลือก'
  }
}

function CONTACT_TYPES(  ){
  return [
    {
      id: null,
      description: 'เลือก'
    },
    {
      id: '1',
      description: 'เจ้าของรถ'
    },
    {
      id: '2',
      description: 'อู่ / ศูนย์บริการ / รถยก'
    },
    {
      id: '9',
      description: 'อื่น ๆ'
    }
  ]
}

export { CONTACT_TYPE, CONTACT_TYPES }